const SCAN_FREQUENCY_LABELS: Record<string, string> = {
  daily: 'Daily',
  twice_daily: 'Twice daily',
  every_6_hours: 'Every 6 hours',
};

export function formatScanFrequency(raw: string): string {
  return SCAN_FREQUENCY_LABELS[raw] ?? raw;
}
